import React from 'react'
import { useTranslation } from 'react-i18next'
import { SocialWebDomainsWidget } from 'schemas/SocialWebDomainsWidgetSchema'
import { useDashboardWidgetSetting } from '../../../../hooks/useDashboardState'
import { toFilter } from '../../../../utils/widgetUtil'
import ErrorMessage from '../../../share/ErrorMessage'
import { getSourceByInsightViewOption } from '../Domains/utils'
import { GuardProps } from '../types'

const isFilterContradictory = (widgetSetting: SocialWebDomainsWidget) => {
  const filter = toFilter(widgetSetting)
  if (!filter.sources) {
    return false
  }

  const sourceType = getSourceByInsightViewOption(widgetSetting.viewOption!)
  return sourceType && !filter.sources.includes(sourceType)
}

const FilterContradictoryGuard = ({ widgetId, children }: GuardProps): React.ReactElement => {
  const widgetSetting = useDashboardWidgetSetting<SocialWebDomainsWidget>(widgetId)
  const { t } = useTranslation()

  if (isFilterContradictory(widgetSetting)) {
    return <ErrorMessage>{t('noDataFoundInWidget')}</ErrorMessage>
  }

  return children
}

export default FilterContradictoryGuard
